import { Badge, BlockStack, Link, Text } from '@shopify/polaris';
import { formatDate, formatToCurrency } from '../../../shared/components/functions';
import { labelFor, toneFor } from '../../../shared/components/approvals/approvalStatus';

// The last invoices of the same supplier: who approved them, on which project, which cost type.
export default function SupplierHistoryCard({ history = [] }) {
  if (!history.length) {
    return (
      <Text variant="bodySm" tone="subdued">
        First invoice of this supplier.
      </Text>
    );
  }
  const cell = { padding: '3px 6px', borderBottom: '1px solid #f0f0f0', fontSize: 12, verticalAlign: 'top' };
  return (
    <BlockStack gap="100">
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          {history.map((item) => (
            <tr key={item.id}>
              <td style={cell}>
                <Link url={`/invoices_in/${item.id}`} removeUnderline>
                  {item.number}
                </Link>
              </td>
              <td style={cell}>{formatDate(item.datum)}</td>
              <td style={{ ...cell, textAlign: 'right' }}>{formatToCurrency(item.BedragExclBtw ?? item.Bedragfaktuur)}</td>
              <td style={cell}>{item.approverAfkorting || '-'}</td>
              <td style={cell}>{item.projectNumber ? `🚧 ${item.projectNumber}` : ''}</td>
              <td style={cell}>{item.costTypeName || ''}</td>
              <td style={cell}>
                <Badge tone={toneFor(item.ApprovalStatus)} size="small">
                  {labelFor(item.ApprovalStatus)}
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </BlockStack>
  );
}
